import { createRoute } from '@tanstack/react-router'
import { AllUsersPage } from '@/features/users/pages/AllUsersPage'
import { Route as usersRoute } from './route'

export const Route = createRoute({
  getParentRoute: () => usersRoute,
  path: '/',
  component: AllUsersPage,
})
